
//  buy button script 
document.addEventListener("DOMContentLoaded", function() {
  const hiddenPlanInput = document.querySelector(".hidden-selling-plan");
  const hiddenVariantInput = document.querySelector(".cs-product-variant");
  const bundleRadios = document.querySelectorAll("input[name='bundle_option']");
  const frequencyInputs = document.querySelectorAll("input[name='frequency_option']");
  const sellingPlanSelects = document.querySelectorAll("select[name='selling_plan']");

  function getActiveSubscriptionDropdown() {
    // Find the dropdown from the visible subscription card
    const visibleCard = document.querySelector(".frequency-card.subscription:not([style*='display: none'])");
    return visibleCard?.querySelector("select[name='selling_plan']") || null;
  }

  function updateInputs(trigger = "auto") {
    const activeBundle = document.querySelector("input[name='bundle_option']:checked");
    const activeFrequency = document.querySelector("input[name='frequency_option']:checked");

    // 🧩 1️⃣ Update variant ID
    if (hiddenVariantInput) {
      hiddenVariantInput.value = activeBundle ? activeBundle.value || "" : "";
    }

    // 🧩 2️⃣ Update selling plan
    if (!hiddenPlanInput) return;
    hiddenPlanInput.value = ""; // default clear

    if (!activeBundle || !activeFrequency) {
      return;
    }

    const activeIndex = Array.from(bundleRadios).indexOf(activeBundle);
    const isSubscription = activeFrequency.closest(".frequency-card")?.classList.contains("subscription");

    if (activeIndex === 0 && isSubscription) {
      const dropdown = getActiveSubscriptionDropdown();
      if (dropdown) {
        hiddenPlanInput.value = dropdown.value || "";
      }
      // 🩹 Double recheck after short delay to ensure it’s captured even if delayed rendering
      setTimeout(() => {
        const laterDropdown = getActiveSubscriptionDropdown();
        if (laterDropdown && !hiddenPlanInput.value) {
          hiddenPlanInput.value = laterDropdown.value || "";
          console.log("💡 (delayed) Selling plan fixed →", hiddenPlanInput.value);
        }
      }, 200);
    } else {
      hiddenPlanInput.value = ""; // clear for other bundles
    }

    console.log(
      `💡 [${trigger}] Variant: ${hiddenVariantInput?.value || "(empty)"} | Selling Plan: ${hiddenPlanInput?.value || "(empty)"}`
    );
  }

  // 🔁 Event listeners
  bundleRadios.forEach(radio => {
    radio.addEventListener("change", () => {
      updateInputs("bundle change");
      // ensure recheck in case subscription dropdown toggles later
      setTimeout(() => updateInputs("bundle delayed recheck"), 200);
    });
  });

  frequencyInputs.forEach(input => {
    input.addEventListener("change", () => updateInputs("frequency change"));
  });

  sellingPlanSelects.forEach(select => {
    select.addEventListener("change", () => updateInputs("plan select"));
  });

  // 🏁 Initialize on load
  setTimeout(() => updateInputs("initial load"), 200);
});

// document.addEventListener("DOMContentLoaded", function() {
//   const bundleRadios = document.querySelectorAll("input[name='bundle_option']");
//   const frequencyInputs = document.querySelectorAll("input[name='frequency_option']");
//   const hiddenVariantInput = document.querySelector(".cs-product-variant");
//   const hiddenPlanInput = document.querySelector(".hidden-selling-plan"); // ✅ correct input for Shopify
//   const hiddenQtyInput = document.querySelector(".new-inp-qty");

//   function updateHiddenInputs() {
//     // 🧠 1️⃣ Variant update
//     const activeBundle = document.querySelector("input[name='bundle_option']:checked");
//     if (activeBundle) {
//       const bundleCard = activeBundle.closest(".bundle-card");
//       const variantId = bundleCard?.dataset.variantId || activeBundle.value || "";
//       hiddenVariantInput.value = variantId;
//     }

//     // 🧠 2️⃣ Selling plan update
//     const activeFrequency = document.querySelector("input[name='frequency_option']:checked");
//     if (activeFrequency) {
//       // Check if it’s a subscription
//       const dropdown = activeFrequency.closest(".frequency-card")?.querySelector("select[name='selling_plan']");
//       if (dropdown) {
//         hiddenPlanInput.value = dropdown.value;
//       } else {
//         hiddenPlanInput.value = ""; // one-time purchase
//       }
//     }

//     // 🧠 3️⃣ Optional quantity
//     const qtyInput = activeBundle?.closest(".bundle-card")?.querySelector("[name^='quntity_']");
//     hiddenQtyInput.value = qtyInput ? qtyInput.value : 1;

//     console.log("Updated inputs =>", {
//       variant_id: hiddenVariantInput.value,
//       selling_plan: hiddenPlanInput.value,
//       quantity: hiddenQtyInput.value
//     });
//   }

//   // 🔁 Events
//   bundleRadios.forEach(radio => radio.addEventListener("change", updateHiddenInputs));
//   frequencyInputs.forEach(input => input.addEventListener("change", updateHiddenInputs));
//   document.querySelectorAll(".frequency-card select[name='selling_plan']").forEach(select => {
//     select.addEventListener("change", updateHiddenInputs);
//   });

//   updateHiddenInputs(); // initialize
// });


document.addEventListener("DOMContentLoaded", function() {
  const bundleRadios = document.querySelectorAll("input[name='bundle_option']");
  const bundleCards = document.querySelectorAll(".bundle-card");
  const frequencyInputs = document.querySelectorAll("input[name='frequency_option']");
  let currentFrequency = "subscription"; // default

  // ----- store original first bundle badge text -----
  const firstBundle = bundleCards[0];
  const firstBadge = firstBundle?.querySelector(".save-badge");
  const firstBadgeOriginalText = firstBadge ? firstBadge.textContent.trim() : null;

  // ----- Show/hide frequency options per bundle -----
  function updateFrequencyVisibility(activeIndex) {
    // Get all frequency cards and identify subscription/one-time
    const allFrequencyCards = document.querySelectorAll(".frequency-card");
    let subscriptionCard = null;
    let oneTimeCard = null;
    
    allFrequencyCards.forEach(card => {
      const input = card.querySelector("input[name='frequency_option']");
      if (!input) return;
      
      // Check if it's subscription by checking for selling plan select or data attribute
      const hasSellingPlan = card.querySelector("select[name='selling_plan']");
      const isSubscription = hasSellingPlan || input.hasAttribute("data-subscription-serving-");
      
      if (isSubscription) {
        subscriptionCard = card;
        card.classList.add("subscription"); // Add class for easier targeting
      } else {
        oneTimeCard = card;
        if (!card.classList.contains("one-time")) {
          card.classList.add("one-time"); // Add class for easier targeting
        }
      }
    });
    
    if (activeIndex === 0) {
      // First bundle is active - show both options
      if (subscriptionCard) subscriptionCard.style.display = "block";
      if (oneTimeCard) oneTimeCard.style.display = "block";
    } else {
      // Other bundle is active - hide subscription, show one-time only
      if (subscriptionCard) subscriptionCard.style.display = "none";
      if (oneTimeCard) oneTimeCard.style.display = "block";
      
      // Auto-select one-time
      const oneTimeInput = oneTimeCard?.querySelector("input[name='frequency_option']");
      if (oneTimeInput) {
        oneTimeInput.checked = true;
        currentFrequency = "onetime";
      }
    }
  }

  // ----- Update badge text (first bundle only) -----
  function updateFirstBadge() {
    if (!firstBadge) return;
    const activeBundle = document.querySelector("input[name='bundle_option']:checked");
    const activeIndex = activeBundle ? Array.from(bundleRadios).indexOf(activeBundle) : 0;
    
    // Only update badge when first bundle is active
    // if (activeIndex === 0) {
    //   if (currentFrequency === "subscription") {
    //     firstBadge.textContent = "Standard Price";
    //   } else {
    //     firstBadge.textContent = firstBadgeOriginalText || "";
    //   }
    // }
  }

  // ----- Update frequency section prices/compare/serving -----
  function updateFrequencySectionPrices() {
    const activeBundle = document.querySelector("input[name='bundle_option']:checked");
    if (!activeBundle) return;

    const activeBundleCard = activeBundle.closest(".bundle-card");
    const activeIndex = Array.from(bundleRadios).indexOf(activeBundle);
    const priceEl = activeBundleCard.querySelector(".price");
    if (!priceEl) return;

    const oneTimePrice = priceEl.getAttribute("data-price-onetime");
    const discountedPrice = priceEl.getAttribute("data-discounted-price");
    const comparePrice = priceEl.getAttribute("data-compare-price");
    const oneTimeServing = priceEl.getAttribute("serving-amount");
    const subscriptionServing = priceEl.getAttribute("subscription-bundle-serving");

    // Update all frequency cards based on active bundle
    const allFrequencyCards = document.querySelectorAll(".frequency-card");
    allFrequencyCards.forEach(card => {
      const input = card.querySelector("input[name='frequency_option']");
      const currentPriceEl = card.querySelector(".current-price");
      const comparePriceEl = card.querySelector(".cs_compare, .compare-price");
      const servingEl = card.querySelector(".serving");
      if (!input) return;

      const isSubscription = card.classList.contains("subscription");

      // Update prices from active bundle
      if (currentPriceEl) {
        currentPriceEl.textContent = isSubscription ? discountedPrice : oneTimePrice;
      }

      // Update compare price
      if (comparePriceEl) {
        if (activeIndex === 0 && isSubscription) {
          // Show compare price for subscription on first bundle
          comparePriceEl.style.display = "inline-block";
          comparePriceEl.textContent = comparePrice;
        } else if (activeIndex === 0 && !isSubscription) {
          // Hide compare price for one-time on first bundle
          comparePriceEl.style.display = "none";
        } else {
          // Show compare price for one-time when other bundles are active
          comparePriceEl.style.display = "inline-block";
          comparePriceEl.textContent = comparePrice;
        }
      }

      // ----- FIXED: Update serving amount with $ sign -----
      if (servingEl) {
        const servingValue = isSubscription ? subscriptionServing : oneTimeServing;
        if (servingValue) {
          const displayValue = servingValue.includes('$') ? servingValue : `$${servingValue}`;
          servingEl.textContent = `${displayValue}/serving`;
        } else {
          servingEl.textContent = '';
        }
      }
    });

    updateFirstBadge();
  }

  // ----- Highlight active frequency card -----
  function updateActiveFrequencyCard() {
    document.querySelectorAll(".frequency-card").forEach(card => {
      const input = card.querySelector("input[name='frequency_option']");
      card.classList.toggle("active", input && input.checked);
    });
  }

  // ----- Events -----
  frequencyInputs.forEach(input => {
    input.addEventListener("change", function() {
      currentFrequency = this.closest(".frequency-card").classList.contains("subscription")
        ? "subscription"
        : "onetime";
      updateFrequencySectionPrices();
      updateActiveFrequencyCard();
    });
  });

  bundleRadios.forEach((radio, index) => {
    radio.addEventListener("change", function() {
      updateFrequencyVisibility(index);
      
      if (index === 0) {
        // First bundle selected - default to subscription
        const subInput = document.querySelector(".frequency-card.subscription input[name='frequency_option']");
        if (subInput) {
          subInput.checked = true;
          currentFrequency = "subscription";
        }
      } else {
        // Other bundle selected - force one-time
        const oneTimeInput = document.querySelector(".frequency-card.one-time input[name='frequency_option']");
        if (oneTimeInput) {
          oneTimeInput.checked = true;
          currentFrequency = "onetime";
        }
      }
      
      updateFrequencySectionPrices();
      updateActiveFrequencyCard();
    });
  });

  // ----- Initial setup -----
  const initiallyChecked = document.querySelector("input[name='bundle_option']:checked");
  const initialIndex = initiallyChecked
    ? Array.from(bundleRadios).indexOf(initiallyChecked)
    : 0;
  updateFrequencyVisibility(initialIndex);
  updateFrequencySectionPrices();
  updateActiveFrequencyCard();
});

